<template>
  <!-- toast -->
  <AlertMsg :msg="msgObj.msg" :show="msgObj.show" :role="msgObj.role" @closePopup="msgObj.show = false"></AlertMsg>
  <!-- end toast -->
  <div class="row">
    <div class="col-12">
      <div class=" d-flex align-items-center">
        <h5 class="mb-0 text-primary"><i class="fas fa-file-text  text-primary"></i> Apply Leave</h5>
      </div>
      <hr>
      <div class="row g-3">
        <div class="col-md-3">
          <label class="form-label">Name of Applier<sup><span class="text-danger font-12">*</span></sup>
            :</label>
          <input type="text" class="form-control form-control-sm" v-model="Obj.NameOfApplier">
        </div>
        <div class="col-md-3">
          <label class="form-label">Apply Date<sup><span class="text-danger font-12">*</span></sup> :</label>
          <input type="date" class="form-control form-control-sm" v-model="Obj.ApplyDate">
        </div>
        <div class=" col-md-3">
          <label class="form-label">Leave Type<sup><span class="text-danger font-12">*</span></sup> :</label>
          <select class="form-select form-select-sm cursor-pointer" role="button" v-model="Obj.LeaveType">
            <option selected=""></option>
            <option value="Casual Leave">Casual Leave</option>
            <option value="Sick Leave">Sick Leave</option>
            <option value="Annual/Vacation Leave">Annual/Vacation Leave</option>
          </select>
        </div>
        <div class="col-md-3">
          <label class="form-label">Leave From<sup><span class="text-danger font-12">*</span></sup> :</label>
          <input type="date" class="form-control form-control-sm" v-model="Obj.LeaveFrom">
        </div>
        <div class="col-md-3">
          <label class="form-label">Leave To<sup><span class="text-danger font-12">*</span></sup> :</label>
          <input type="date" class="form-control form-control-sm" v-model="Obj.LeaveTo">
        </div>
        <div class="col-md-3">
          <label class="form-label">Reason<sup><span class="text-danger font-12">*</span></sup> :</label>
          <textarea class="form-control form-control-sm" type="text" v-model="Obj.Reason"></textarea>
        </div>
        <div class="col-md-3">
          <label class="form-label">File :</label>
          <label for="fileInput" class="attachment-icon" >
              <i class="fa fa-upload"></i>
            </label>
          <input class="form-control" id="fileInput" type="file" multiple accept=".png,.jpg,.jpeg,.webp,.pdf,.docx,.doc,.xls,.txt" @change="UploadImg" />
          <div class="d-flex align-items-start">
          <a v-if="Obj.Image" :href="getUrl(Obj.Image)" target="_blank"  class="clearfix">{{Obj.Image.substring(Obj.Image.lastIndexOf('/') + 1)  }} </a>
          <i role="button" v-if="Obj.Image !== ''" @click="deleteFile(Obj.Image)" class="fa-solid fa-x text-danger f-5 mt-2 ms-1"></i>
        </div></div>
        <div class="col-md-3 mt-5 text-end">
          <button class="btn btn-sm btn-darknavy me-1" @click="save()"><i
              class="fa fa-save"></i> Save</button>
          <button type="button" class="btn btn-sm btn-soft-dark" @click="reset()"><i class="fa fa-times-circle  me-1"></i> Cancel</button>
        </div>
      </div>
      <ul v-if="errors.length" class="text-danger ps-3">
          <li v-for="(err, index) in errors" :key="index">{{ err }}</li>
        </ul>
      <div class="row mt-3">
        <div class="col-sm-12 table-responsive">
           <div class="progress mb-0 progress-sm" v-if="progress!=0">
        <div class="progress-bar" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"
          :style="{ width: progress + '%' }"></div>
      </div>
          <DataTable v-if="progress==0" :columns="cols" :rows="rows" :pageSize="10"   :actions="{  edit: handleEdit, delete: handleDelete, drpRow:drpRow }" />
        </div>
      </div>
    </div>
  </div>
  <DelPopup :name="delObj.NameOfApplier" @delRecord="delRecord" @closeModal="delObj.NameOfApplier = ''"></DelPopup>
</template>
<script setup>
import AlertMsg from "@/components/Common/AlertMsg.vue";
import DelPopup from "@/components/Common/DelPopup.vue";
import DataTable from "@/components/Common/DataTable.vue";
import { isRequired, validateForm } from '@/utils/validation.js';
import { useFileUpload } from '@/utils/fileUpload';
const { handleFileUploadImg } = useFileUpload()
import { formatDate, curdStatus, api } from '@/utils/helpers.js';
import { ref, onMounted} from 'vue'
import { useStore } from 'vuex' 
const store = useStore() 
const userId = store.state.userID;
  const  Obj = ref({NameOfApplier: "", ApplyDate: new Date().toISOString().slice(0, 10), LeaveType: "", LeaveFrom: new Date().toISOString().slice(0, 10), LeaveTo: new Date().toISOString().slice(0, 10), Reason: "", Image: "", ApprovalStatus: "",UserID: "" })
    const   msgObj= ref({ msg: "", role: "", show: false, })
    const   delObj = ref({})
    const   errors= ref({})
const cols=ref([
  { label: 'S.No', key: 'Sno' },
  { label: 'Name', key: 'NameOfApplier' },
  { label: 'LeaveType', key: 'LeaveType',  },
  { label: 'LeaveFrom', key: 'FromDate' },
  { label: 'LeaveTo', key: 'ToDate'  },
  { label: 'Reason', key: 'Reason',truncatable: true  },
   { label: 'File', key: 'Image', type:'image', },
  { label: 'ApprovalStatus', key: 'ApprovalStatus', type:'drp', items:['Approved', 'Pending', 'NotApproved'] },
  { label: 'Status', key: 'status', type: 'badge' },
]);

const handleEdit = (row) => {
    Obj.value = { ...row ,
    LeaveFrom: row.LeaveFrom ? row.LeaveFrom.slice(0, 10) : new Date().toISOString().slice(0, 10),
     LeaveTo: row.LeaveTo ? row.LeaveTo.slice(0, 10) : new Date().toISOString().slice(0, 10),
     ApplyDate: row.ApplyDate ? row.ApplyDate.slice(0, 10) : new Date().toISOString().slice(0, 10),
    }
     if (Obj.value.Image?.startsWith(process.env.VUE_APP_API_URL)) {
    Obj.value.Image = Obj.value.Image.replace(process.env.VUE_APP_API_URL, '');
  }
}
const handleDelete = (row) => {
  delObj.value = { ...row };
}
const drpRow = async(row, val) =>{
      await api.put(`/leave/statusUpdate/${row._id}`, { status: val })
        .then(() => { loadData(); reset();
          msgObj.value = { msg: `Leave Status Updated`, role: "success", show: true, };
        })
        .catch((error) => { console.log(error); });
}
const rows=ref([])
const UploadImg = async (event) => {
  const file = event.target.files[0];
  if (!file) return;
const { file: uploadedFile, message } = await handleFileUploadImg(file);
  if (message) {
    msgObj.value = { msg: message, role: "danger", show: true };
    event.target.value = ""; 
    return;
  }
  if (uploadedFile) { Obj.value.Image = uploadedFile; }
event.target.value = null;
};
 const  save =async() => {
      const fields = {
        NameOfApplier: { value: Obj.value.NameOfApplier, validators: [isRequired], },
         ApplyDate: { value: Obj.value.ApplyDate, validators: [isRequired], },
        LeaveType: { value: Obj.value.LeaveType, validators: [isRequired], },
         LeaveFrom: { value: Obj.value.LeaveFrom, validators: [isRequired], },
         LeaveTo: { value: Obj.value.LeaveTo, validators: [isRequired], },
        Reason: { value: Obj.value.Reason, validators: [isRequired], },
      };
      errors.value = validateForm(fields);

      if (Object.keys(errors.value).length === 0) {
          if (!Obj.value._id) {
      Obj.value.UserID = userId; 
    }
        const { url, method, msg } = curdStatus(Obj.value);
        await api[method](`/Leave${url}`, Obj.value)
          .then(() => {
            loadData();
            reset();
            msgObj.value = { msg: `Leave ${msg} Successfuly`, role: "success", show: true, };
          })
          .catch((error) => { console.log(error); });
      }
    }
    const reset= async()=> {
      Obj.value = { NameOfApplier: "", ApplyDate: new Date().toISOString().slice(0, 10), LeaveType: "", LeaveFrom: new Date().toISOString().slice(0, 10), LeaveTo: new Date().toISOString().slice(0, 10), Reason: "", Image: "", ApprovalStatus: "",UserID: "" };
      msgObj.value = { msg: "", role: "", show: false, };
      errors.value={};
    }
      const progress = ref(0)
    const loadData = async()=> {
          let direction = 1
     let progressInterval = setInterval(() => {
       progress.value += direction
       if (progress.value >= 100) {
         progress.value = 0 
       }
     }, 100)
      await api.get('/Leave/all') .then((response) => { rows.value = response.data.map((item, i) => ({ ...item, Sno: i + 1,FromDate: formatDate(item.LeaveFrom),
  ToDate: formatDate(item.LeaveTo),Image: item.Image,Status: item.status || '',
 })); 
  progress.value = 0
  clearInterval(progressInterval)
});
    }
    const deleteFile = async (filePath) => {
      if (!filePath) return;
      const fileName = filePath.split('/').pop();

      try {
        await api.delete(`/documents/students?filename=${fileName}`);
        Obj.value.Image = '';
      } catch (err) {
        msgObj.value = { msg: 'Failed to delete image.', role: 'danger', show: true };
      }
    };
    const delRecord= async()=> {
      await api.delete(`/Leave/${delObj.value._id}`)
        .then(() => {
          loadData();
          delObj.value={};
          msgObj.value = { msg: "Leave Deleted Successfuly.", role: "danger", show: true, };
        });
    }
    const getUrl= (img)=> {
      let imgUrl = img.startsWith("..")
          ? img.substring(2)
          : img;
      
  const base = process.env.VUE_APP_API_URL.replace(/\/+$/, "");
  const path = imgUrl.replace(/^\/+/, "");
  return `${base}/${path}`;
    }
    onMounted(() => { loadData() })
</script>